import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="email-template"
export default class extends Controller {
  static values = {
    templates: Object,
  };

  static targets = ['subject', 'body'];

  change(event) {
    const template = this.templatesValue[event.target.value] || null;
    this.subjectTarget.value = template?.subject || '';
    this.bodyTarget.value = template?.body || '';
  }
}
